import axios from "axios";

const fetchVendors = (params, config) => {
  return axios.get(`/api/v1/failed_vendors`, {
    params,
    ...config,
  });
};

const deleteVendor = (id) => {
  return axios.delete(`/api/v1/failed_vendors/${id}`);
};

const exportToExcel = () => {
  return axios({
    url: `/api/v1/failed_vendors/export`,
    method: "GET",
    responseType: "blob",
  });
};

const FailedVendors = {
  fetchVendors,
  deleteVendor,
  exportToExcel,
};

export default FailedVendors;
